import { createListenerMiddleware } from '@reduxjs/toolkit';

import {
    collectionPageActions,
    detailViewActions,
    globalNavigationActions,
    resetAlertStore,
    resetFeaturesStore,
    resetTwoFactorAuthStore,
    resetYatPageStore,
    wishlistActions,
} from '@app/store/slices';

import { ACTION_RESET_ADMIN_INFO_STORE } from './types/admin-info';
import { ACTION_RESET_ARTIFACTS_STORE } from './types/artifacts-actions';
import { ACTION_RESET_CRYPTO_STORE } from './types/crypto';
import { ACTION_RESET_DASHBOARD_STORE } from './types/dashboard';
import { ACTION_RESET_DISPLAY_STORE } from './types/display';
import { ACTION_RESET_EMOJI_STORE } from './types/emoji';
import { ACTION_RESET_LOADER_STORE } from './types/loader';
import { ACTION_RESET_NFT_STORE } from './types/nft';
import { ACTION_RESET_NFT_MANAGER_STORE } from './types/nft-manager';
import { ACTION_RESET_NOTIFICATION_STORE } from './types/notification';
import { ACTION_RESET_ORGANIZATIONS_STORE } from './types/organizations';
import { ACTION_RESET_PARTNER_INTEGRATIONS_STORE } from './types/partner-integrations';
import { ACTION_RESET_PICKER_STORE } from './types/picker';
import { ACTION_RESET_TRANSFERS_STORE } from './types/transfers';
import { ACTION_RESET_USER_STORE } from './types/user';

/**
 * This middleware lets us intercept actions and run custom logic. Right now we'll use it for
 * resetting all stores after a logout.
 * [Usage Guide](https://redux-toolkit.js.org/api/createListenerMiddleware#usage-guide)
 */
export const listenerMiddlewareInstance = createListenerMiddleware({
    // eslint-disable-next-line no-console
    onError: () => console.error,
});

export const startAppListening = listenerMiddlewareInstance.startListening({
    type: 'ACTION_RESET_REDUX_STORE',
    effect: async (_, listenerApi) => {
        // Redux store reset - Reducers
        listenerApi.dispatch({ type: ACTION_RESET_ADMIN_INFO_STORE });
        listenerApi.dispatch({ type: ACTION_RESET_ARTIFACTS_STORE });
        listenerApi.dispatch({ type: ACTION_RESET_CRYPTO_STORE });
        listenerApi.dispatch({ type: ACTION_RESET_DASHBOARD_STORE });
        listenerApi.dispatch({ type: ACTION_RESET_DISPLAY_STORE });
        listenerApi.dispatch({ type: ACTION_RESET_EMOJI_STORE });
        listenerApi.dispatch({ type: ACTION_RESET_LOADER_STORE });
        listenerApi.dispatch({ type: ACTION_RESET_NFT_MANAGER_STORE });
        listenerApi.dispatch({ type: ACTION_RESET_NFT_STORE });
        listenerApi.dispatch({ type: ACTION_RESET_NOTIFICATION_STORE });
        listenerApi.dispatch({ type: ACTION_RESET_ORGANIZATIONS_STORE });
        listenerApi.dispatch({ type: ACTION_RESET_PARTNER_INTEGRATIONS_STORE });
        listenerApi.dispatch({ type: ACTION_RESET_PICKER_STORE });
        listenerApi.dispatch({ type: ACTION_RESET_TRANSFERS_STORE });
        listenerApi.dispatch({ type: ACTION_RESET_USER_STORE });

        // Redux store reset - Slices
        listenerApi.dispatch(resetAlertStore());
        listenerApi.dispatch(resetFeaturesStore());
        listenerApi.dispatch(resetTwoFactorAuthStore());
        listenerApi.dispatch(resetYatPageStore());
        listenerApi.dispatch(collectionPageActions.resetCollectionPageStore());
        listenerApi.dispatch(detailViewActions.resetDetailViewStore());
        listenerApi.dispatch(globalNavigationActions.resetGlobalNavigationStore());
        listenerApi.dispatch(wishlistActions.resetWishlistStore());
    },
});
